// Dependencies

// Find last valid match path
const findLastMatchPath = (currentPath, paths) => {
  const findedPaths = paths.filter((path) => {
    return currentPath.indexOf(path) !== -1;
  });

  const results = findedPaths.length;
  const result = results && findedPaths[results - 1];
  return result && result;
};

export default findLastMatchPath;
